import { generateTestIndexes } from '../../options-list/utils/test-indexes';
import { filterOptions } from './filter-options';
import { flattenOptions } from './flatten-options';
export function prepareOptions(options, filteringType, filteringText) {
    const { flatOptions, parentMap } = flattenOptions(options);
    const filteredOptions = filteringType !== 'auto' ? flatOptions : filterOptions(flatOptions, filteringText);
    generateTestIndexes(filteredOptions, parentMap.get.bind(parentMap));
    return {
        flatOptions,
        filteredOptions,
        parentMap,
        totalCount: flatOptions.length,
        matchesCount: filteredOptions.length,
    };
}
//# sourceMappingURL=prepare-options.js.map